// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"45ec98cf","396":"2da5efd6","453":"42be0865","455":"68230695","857":"98310815","977":"153ab69c"}[chunkId] + ".chunk.js";
};